import React, { useEffect } from 'react';
import './conteudo-painel-menu.component.scss';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Tabs, TextField } from '@mui/material';
import Tab from '@mui/material/Tab';
import { useInput } from '../../hooks/useInput.hook';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import MenuModel, { ItensMenuModel } from '../../models/menu.model';
import { CONSTANTS } from '../../constants/constants';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddIcon from '@mui/icons-material/Add';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CamposMenuComponent from '../campos-menu/campos-menu.component';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import FileWpModel from '../../models/file-wp.model';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type ConteudoPainelMenuProps = {
  setVal: (val: MenuModel) => void;
  menu?: MenuModel;
}

function ConteudoPainelMenuComponent(props: ConteudoPainelMenuProps) {

  const { value: nomeSiteInputText, bind: bindNomeSiteInputText, setValue: setNomeSiteInputText } = useInput(props.menu?.nome_do_site);
  const [tipoMenu, setTipoMenu] = React.useState(props.menu?.tipo_menu);
  const [posicaoLogo, setPosicaoLogo] = React.useState(props.menu?.posicao_logo);
  const [favIcon, setFavIcon] = React.useState<FileWpModel>(props.menu?.favicon ? props.menu?.favicon : { id: '', src: '' });
  const [logo, setLogo] = React.useState<FileWpModel>(props.menu?.logo ? props.menu?.logo : { id: '', src: '' });

  const [corFundo, setCorFundo] = React.useState(props.menu?.cor_bg_menu);
  const [corTextoMenu, setCorTextoMenu] = React.useState(props.menu?.cor_texto_menu);
  const [corFundoSubmenu, setCorFundoSubmenu] = React.useState(props.menu?.cor_fundo_submenu);
  const [corTextoSubmenu, setCorTextoSubmenu] = React.useState(props.menu?.cor_texto_submenu);

  const [itensMenu, updateItensMenu] = React.useState<any>(props.menu?.itens ? props.menu?.itens : []);

  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  useEffect(() => {
    atualizaMenu();
  }, [itensMenu]);

  const addMenu = () => {
    const items = [...itensMenu];
    const newItem: ItensMenuModel = {
      descricao: '',
      id_do_componente: '',
      nome: '',
      palavras_chave: '',
      sem_acao: false,
      submenu: '',
      id: 'menu-' + itensMenu.length
    };

    items.push(newItem);

    updateItensMenu(items);
  };

  const handleOnDragEnd = (result: any) => {

    const items = Array.from(itensMenu);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    updateItensMenu(items);
  }

  const handleChageItemMenu = (item: ItensMenuModel) => {

    const items = [...itensMenu];
    const itemEncontrado: ItensMenuModel = items.find(
      a => a.id === item.id
    );
    itemEncontrado.descricao = item.descricao;
    itemEncontrado.id_do_componente = item.id_do_componente;
    itemEncontrado.nome = item.nome;
    itemEncontrado.palavras_chave = item.palavras_chave;
    itemEncontrado.sem_acao = item.sem_acao;
    itemEncontrado.submenu = item.submenu;
    updateItensMenu(items);
  }

  const removerItemMenu = (id?: string) => {
    updateItensMenu(
      itensMenu.filter(a =>
        a.id !== id
      )
    );
  }

  const atualizaMenu = () => {
    props.setVal({
      author_id: props.menu ? props.menu.author_id : '',
      cor_bg_menu: corFundo ? corFundo : '',
      cor_fundo_submenu: corFundoSubmenu ? corFundoSubmenu : '',
      cor_texto_menu: corTextoMenu ? corTextoMenu : '',
      cor_texto_submenu: corTextoSubmenu ? corTextoSubmenu : '',
      favicon: favIcon ? favIcon : { id: '', src: '' },
      itens: itensMenu ? itensMenu : '',
      logo: logo ? logo : { id: '', src: '' },
      nome_do_site: nomeSiteInputText,
      posicao_logo: posicaoLogo ? posicaoLogo : '',
      tipo_menu: tipoMenu ? tipoMenu : ''
    });
  }

  return (
    <section className="conteudo-painel-menu">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTabs}
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
            <Tab label="Estilo" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <h2>Menu</h2>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select w50'>
            <InputLabel id="demo-select-small-label">Tipo menu</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={tipoMenu}
              label="Age"
              onChange={(event) => setTipoMenu(event.target.value)}
            >
              <MenuItem value="">
                <em>Selelcione</em>
              </MenuItem>
              <MenuItem value={CONSTANTS.TIPO_MENU.SCROLL}>Scroll</MenuItem>
              <MenuItem value={CONSTANTS.TIPO_MENU.NOVA_PAGINA}>Nova página</MenuItem>
            </Select>
          </FormControl>
          <TextField {...bindNomeSiteInputText} label="Nome do site" className='w50' />
          <div className="logos">
            <AttachmentModalComponent setVal={(attachFile) => setFavIcon(attachFile)} file={favIcon} legenda='Favicon' />
            <AttachmentModalComponent setVal={(attachFile) => setLogo(attachFile)} file={logo} legenda='Logo' />
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='select'>
              <InputLabel id="demo-select-small-label">Posição logo</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={posicaoLogo}
                label="Posição logo"
                onChange={(event) => setPosicaoLogo(event.target.value)}
              >
                <MenuItem value="">
                  <em>Selelcione</em>
                </MenuItem>
                <MenuItem value={CONSTANTS.POSICAO_LOGO.ESQUERDA}>{CONSTANTS.POSICAO_LOGO.ESQUERDA}</MenuItem>
                <MenuItem value={CONSTANTS.POSICAO_LOGO.CENTRO}>{CONSTANTS.POSICAO_LOGO.CENTRO}</MenuItem>
                <MenuItem value={CONSTANTS.POSICAO_LOGO.DIREITA}>{CONSTANTS.POSICAO_LOGO.DIREITA}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <h2>Menus</h2>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="itens-menu">
              {(provided) => (
                <div className="itens-menu" {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    itensMenu?.map((item, iMenu) => (
                      <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                        {(provided) => (
                          <Accordion ref={provided.innerRef} {...provided.draggableProps} >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={item.id + '-content'}
                              id={item.id + '-header'}
                              {...provided.dragHandleProps}
                            >
                              <Typography component="span"><OpenWithIcon /> {item.nome}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <CamposMenuComponent
                                index={iMenu}
                                itemMenu={item}
                                itensMenu={itensMenu}
                                setVal={(val) => handleChageItemMenu(val)}
                                removeItem={(id) => removerItemMenu(id)}
                              />
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </Draggable>
                    ))
                  }
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="bts">
            <Button className='bt add' onClick={addMenu}><AddIcon />Adicionar menu</Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <h2>Estilo do menu</h2>
          <label className='w50'>
            <span>Cor do fundo:</span>
            <input type='color' value={corFundo} onChange={(val) => setCorFundo(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto:</span>
            <input type='color' value={corTextoMenu} onChange={(val) => setCorTextoMenu(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do fundo submenu:</span>
            <input type='color' value={corFundoSubmenu} onChange={(val) => setCorFundoSubmenu(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto submenu:</span>
            <input type='color' value={corTextoSubmenu} onChange={(val) => setCorTextoSubmenu(val.currentTarget.value)} />
          </label>
        </CustomTabPanel>
      </Box>
    </section>
  );
}

export default ConteudoPainelMenuComponent;
